import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, TextField, Tooltip, MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef, useState } from "react";
import { ADMIN_SERVER_BASE_URL } from '../util/apiClient';

interface IEddProps {
  editPartenaire: IPartner;
  setEditPartenaire: (x: IPartner) => void;
  selectedPhoto: any;
  setSelectedPhoto: (x: any) => void;
}


export interface IPartner {
  libelle: string;
  logoPartenaire: string;
}

const Edit = (props: IEddProps) => {

  //props
  const {
    editPartenaire,
    setEditPartenaire,
    setSelectedPhoto
  } = props

  //
  //hooks
  const selectPhoto: any = useRef(null);
  const [image, setImage] = useState<string>("");


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditPartenaire({ ...editPartenaire, [name]: value })
  }



  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <Grid item md={12} xs={12} sm={12}>
            <TextField
              fullWidth
              size="small"
              name="libelle"
              label="libellé partenaire"
              value={editPartenaire.libelle}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item md={12} xs={12} sm={12}>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <Tooltip title="Charger l'image descriptive de l'actualité">
                  <Button
                    variant="outlined"
                    color="primary"
                    component="label"
                    startIcon={<ImageIcon />}
                    style={{ marginTop: 10, width: "100%" }}
                    onClick={() => {
                      selectPhoto?.current?.click();
                    }}
                  >
                    Charger le logo
                  </Button>
                </Tooltip>
                <input
                  hidden
                  multiple
                  type="file"
                  name="pieceJointe"
                  ref={selectPhoto}
                  onChange={(e: any) => {
                    const files = e.target.files[0];
                    if (files) {
                      const img = URL.createObjectURL(files);
                      setImage(img);
                      setSelectedPhoto(e.target.files[0]);
                    }
                  }}
                />
              </Grid>
              <Grid item md={6} xs={12} sm={6}>
                <img
                  src={
                    Object.keys(image).length > 0
                      ? image
                      : editPartenaire.logoPartenaire
                  }
                  style={{ width: "5vw", height: "auto" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>);
};

export default Edit;





